const promotionList = () => import('@/pages/promotion/list/index.vue');

export default [{
    path: '/promotion/list',
    component: promotionList,
    meta: [{
        name: '推广管理',
		activeRoute: '/promotion/manage'
    },
    {
        name: '推广列表',
        activeRoute: '/promotion/list'
    }]
}];